import React, { useState, ChangeEvent, KeyboardEvent } from "react";
import { isValidInternationalPhone } from "../../utils/utils";
import { tWithKeyAttr as t } from "../../i18nHelper";
import styles from "./phoneExistsPopup.module.css";
import doctor from "../../images/questionnaire_doctor.png";

interface PhoneExistsPopupProps {
  onConfirmNewPhone: (newPhone: string) => void;
  onContinueWithExisting: () => void;
}

const PhoneExistsPopup: React.FC<PhoneExistsPopupProps> = ({
  onConfirmNewPhone,
  onContinueWithExisting,
}) => {
  const [showPhoneInput, setShowPhoneInput] = useState(false);
  const [newPhone, setNewPhone] = useState("");
  const [error, setError] = useState<string | null>(null);

  const handleTelInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    const cleaned = inputValue.replace(/[^0-9+()-]/g, "");
    const normalized = cleaned.replace(/(?!^)[+]/g, "");
    const noSpaces = normalized.replace(/\s+/g, "");
    setNewPhone(noSpaces.slice(0, 20));
    setError(null);
  };

  const handleSubmitNewPhone = () => {
    if (!newPhone.trim()) {
      setError(t("PLEASE_ENTER_PHONE"));
      return;
    }
    if (!isValidInternationalPhone(newPhone)) {
      setError(t("INVALID_MOBILE_NUMBER", { textToSubmit: newPhone }));
      return;
    }
    onConfirmNewPhone(newPhone);
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleSubmitNewPhone();
    }
  };

  if (showPhoneInput) {
    return (
      <article className={styles.popup} data-testid="phone-exists-popup">
        <h2 className={styles.popup__title}>{t("ENTER_NEW_PHONE")}</h2>
        <img src={doctor} alt="Doctor" className={styles.popup__img} />
        <input
          type="text"
          className={styles.popup__input}
          value={newPhone}
          onChange={handleTelInputChange}
          onKeyDown={handleKeyDown}
          placeholder={t("PHONE_PLACEHOLDER") || ""}
          autoFocus
        />
        {error && <p className={styles.popup__error}>{error}</p>}
        <button
          type="button"
          className={`${styles.popup__btn} hover`}
          onClick={handleSubmitNewPhone}
        >
          {t("CONFIRM")}
        </button>
        <button
          type="button"
          className={`${styles.popup__btn} hover`}
          onClick={() => setShowPhoneInput(false)}
        >
          {t("BACK")}
        </button>
      </article>
    );
  }

  return (
    <article className={styles.popup} data-testid="phone-exists-popup">
      <h2 className={styles.popup__title}>{t("PHONE_EXISTS_IN_SYSTEM")}</h2>
      <p className={styles.popup__text}>{t("PHONE_EXISTS_QUESTION")}</p>
      <p className={styles.popup__small_text}>{t("ADD_ADDITIONAL_USER_UNDER_CONTACT")}</p>
      <img src={doctor} alt="Doctor" className={styles.popup__img} />
      <button
        type="button"
        className={`${styles.popup__btn} hover`}
        onClick={() => setShowPhoneInput(true)}
      >
        {t("YES")}
      </button>
      <button
        type="button"
        className={`${styles.popup__btn} hover`}
        onClick={onContinueWithExisting}
      >
        {t("NO")}
      </button>
    </article>
  );
};

export default PhoneExistsPopup;
